const URL_REGEX = /https?:\/\/[^\s<>"]+/g;

/**
 * 渲染含換行與可點擊 URL 的使用者文字內容
 * @param {{ text: string, className?: string }} props
 */
const FormattedText = ({ text, className }) => {
    if (!text) return null;

    const parts = [];
    let lastIndex = 0;
    let match;

    URL_REGEX.lastIndex = 0;
    while ((match = URL_REGEX.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        parts.push(
            <a
                key={match.index}
                href={match[0]}
                target="_blank"
                rel="noopener noreferrer"
            >
                {match[0]}
            </a>
        );
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return (
        <span className={className} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {parts}
        </span>
    );
};

export default FormattedText;
